var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"icon iconfont",class:_vm.type,style:({'color':_vm.color,'font-size': _vm.fontSize + 'px'})})
}
var staticRenderFns = []

export { render, staticRenderFns }